import React from 'react';

export const SlackSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="white"
			/>
			<path
				d="M0.513685 8C0.513685 3.86542 3.86542 0.513685 8 0.513685H24C28.1346 0.513685 31.4863 3.86542 31.4863 8V24C31.4863 28.1346 28.1346 31.4863 24 31.4863H8C3.86542 31.4863 0.513685 28.1346 0.513685 24V8Z"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.02737"
			/>
			<g>
				<path
					d="M10.6616 18.5983C10.6616 19.7479 9.7325 20.677 8.58289 20.677C7.43328 20.677 6.50415 19.7479 6.50415 18.5983C6.50415 17.4487 7.43328 16.5195 8.58289 16.5195H10.6616V18.5983ZM11.701 18.5983C11.701 17.4487 12.6301 16.5195 13.7797 16.5195C14.9293 16.5195 15.8585 17.4487 15.8585 18.5983V23.7951C15.8585 24.9447 14.9293 25.8739 13.7797 25.8739C12.6301 25.8739 11.701 24.9447 11.701 23.7951V18.5983Z"
					fill="#E01E5A"
				/>
				<path
					d="M13.7796 10.2517C12.63 10.2517 11.7009 9.32258 11.7009 8.17298C11.7009 7.02337 12.63 6.09424 13.7796 6.09424C14.9292 6.09424 15.8584 7.02337 15.8584 8.17298V10.2517H13.7796ZM13.7796 11.3068C14.9292 11.3068 15.8584 12.236 15.8584 13.3856C15.8584 14.5352 14.9292 15.4643 13.7796 15.4643H8.56702C7.41742 15.4643 6.48828 14.5352 6.48828 13.3856C6.48828 12.236 7.41742 11.3068 8.56702 11.3068H13.7796Z"
					fill="#36C5F0"
				/>
				<path
					d="M22.1104 13.3856C22.1104 12.236 23.0396 11.3068 24.1892 11.3068C25.3388 11.3068 26.2679 12.236 26.2679 13.3856C26.2679 14.5352 25.3388 15.4643 24.1892 15.4643H22.1104V13.3856ZM21.0711 13.3856C21.0711 14.5352 20.1419 15.4643 18.9923 15.4643C17.8427 15.4643 16.9136 14.5352 16.9136 13.3856V8.17298C16.9136 7.02337 17.8427 6.09424 18.9923 6.09424C20.1419 6.09424 21.0711 7.02337 21.0711 8.17298V13.3856Z"
					fill="#2EB67D"
				/>
				<path
					d="M18.9923 21.7164C20.1419 21.7164 21.0711 22.6455 21.0711 23.7951C21.0711 24.9447 20.1419 25.8739 18.9923 25.8739C17.8427 25.8739 16.9136 24.9447 16.9136 23.7951V21.7164H18.9923ZM18.9923 20.677C17.8427 20.677 16.9136 19.7479 16.9136 18.5983C16.9136 17.4487 17.8427 16.5195 18.9923 16.5195H24.2049C25.3545 16.5195 26.2837 17.4487 26.2837 18.5983C26.2837 19.7479 25.3545 20.677 24.2049 20.677H18.9923Z"
					fill="#ECB22E"
				/>
			</g>
		</svg>
	);
};
